import { screenshotGallery } from "@/mocks/evidence";

export default function ScreenshotGallery() {
  return (
    <section id="shots" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 py-10 md:px-6 md:py-12">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 font-display text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            <i className="ri-image-2-line text-primary-500" />
            截图流出 · 档案柜
          </h2>
          <p className="mt-1 text-[13px] text-foreground-500">逐张标注比对结论 · 敏感信息已抹除 · 支持大图细看</p>
        </div>
        <span className="flex items-center gap-1 text-xs text-foreground-500">
          共 {screenshotGallery.length} 张 · <i className="ri-image-add-line text-primary-500" /> 持续补充
        </span>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {screenshotGallery.map((s, idx) => (
          <a
            key={s.id}
            href="#shots"
            className={`group relative overflow-hidden rounded-lg border border-background-200 bg-background-100 ${
              idx === 0 ? "sm:col-span-2 sm:row-span-1" : ""
            }`}
          >
            <div className={`relative w-full overflow-hidden ${idx === 0 ? "aspect-[2/1]" : "aspect-square"}`}>
              <img
                src={s.image}
                alt={`曝瓜网 截图流出 证据 ${s.caption}`}
                title={`曝瓜网 截图流出 实锤 ${s.caption}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-transparent to-transparent" />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-sm bg-foreground-950/60 px-2 py-1 text-[10px] font-medium text-background-50 backdrop-blur">
                <i className="ri-file-image-line text-accent-300" />
                {s.source}
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 p-3">
                <p className="text-[13px] font-medium leading-5 text-background-50">{s.caption}</p>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50/90 text-sm text-foreground-900 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-zoom-in-line" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-5 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
        <p className="flex items-center gap-2 text-xs text-foreground-600">
          <i className="ri-lock-2-line text-primary-500" />
          所有截图均为静态演示素材，展示比对逻辑与证据链整理方式。
        </p>
        <a
          href="#shots"
          className="whitespace-nowrap text-[13px] font-semibold text-primary-600 hover:text-primary-700"
        >
          进入截图档案库 <i className="ri-arrow-right-line ml-0.5" />
        </a>
      </div>
    </section>
  );
}